import * as React from 'react'

const Footer: React.SFC<{}> = ({}) => (
	<section className="cta-section">
		<div className="w-container">
			<div className="w-layout-grid grid-2"><a href="https://www.idealmri.com/why-ideal-mri" id="w-node-774288a9e25a-774089fe"
													 className="cta-grid-item w-inline-block"><img
				src="https://uploads-ssl.webflow.com/5b9e87c40899a487ba8091e4/5b9ead31fb9e09c21b36b101_Why.svg" alt=""
				className="cta-button-image"/>
				<div id="w-node-774288a9e25c-774089fe">Why ideal MRI</div>
			</a><a href="https://www.idealmri.com/what-to-expect" id="w-node-774288a9e25e-774089fe"
				   className="cta-grid-item w-inline-block"><img
				src="https://uploads-ssl.webflow.com/5b9e87c40899a487ba8091e4/5b9ead2f69d670128b342c0a_Expect.svg"
				alt="" className="cta-button-image"/>
				<div>What to Expect</div>
			</a>
			{/* <a href="https://www.idealmri.com/meet-our-team" id="w-node-774288a9e262-774089fe" className="cta-grid-item w-inline-block"><img
				src="https://uploads-ssl.webflow.com/5b9e87c40899a487ba8091e4/5b9ead2f3661e73d2f76eedd_Meet%20Our%20Team.svg"
				alt="" className="cta-button-image"/>
				<div>Meet Our Team</div>
			</a> */}
			<a href="https://www.idealmri.com/for-clinicians" id="w-node-774288a9e266-774089fe"
				   className="cta-grid-item w-inline-block"><img
				src="https://uploads-ssl.webflow.com/5b9e87c40899a487ba8091e4/5b9ead313661e7266876eedf_Providers.svg"
				alt="" className="cta-button-image"/>
				<div>For Clinicians</div>
			</a><a href="https://www.idealmri.com/pricing-and-insurance" id="w-node-774288a9e26a-774089fe"
				   className="cta-grid-item w-inline-block"><img
				src="https://uploads-ssl.webflow.com/5b9e87c40899a487ba8091e4/5b9ead313661e7547b76eee0_Pricing.svg"
				alt="" className="cta-button-image"/>
				<div>Pricing &amp; Insurance</div>
			</a><a href="https://www.idealmri.com/come-see-us" id="w-node-774288a9e26e-774089fe" className="cta-grid-item w-inline-block"><img
				src="https://uploads-ssl.webflow.com/5b9e87c40899a487ba8091e4/5b9ead2f08470e4beefa3f54_Find%20Us.svg"
				alt="" className="cta-button-image"/>
				<div>Find Us</div>
			</a></div>
		</div>
	</section>
);

export default Footer
